"use strict";
/* eslint-disable object-curly-newline */

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20230401/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      "1": 76191,
      "2": 89932,
      "3": 113035,
      "4": 121062
    },
    AL: {
      "1": 56598,
      "2": 67953,
      "3": 77419,
      "4": 94659
    },
    AR: {
      "1": 51164,
      "2": 63835,
      "3": 74475,
      "4": 86039
    },
    AZ: {
      "1": 64172,
      "2": 80249,
      "3": 90193,
      "4": 104143
    },
    CA: {
      "1": 75235,
      "2": 93175,
      "3": 104785,
      "4": 122707
    },
    CO: {
      "1": 75710,
      "2": 98365,
      "3": 113822,
      "4": 134146
    },
    CT: {
      "1": 81909,
      "2": 100639,
      "3": 121958,
      "4": 142596
    },
    DC: {
      "1": 86370,
      "2": 146440,
      "3": 146440,
      "4": 204686
    },
    DE: {
      "1": 71279,
      "2": 83174,
      "3": 103598,
      "4": 122908
    },
    FL: {
      "1": 60429,
      "2": 74131,
      "3": 83396,
      "4": 100476
    },
    GA: {
      "1": 60490,
      "2": 77183,
      "3": 87742,
      "4": 103638
    },
    GU: {
      "1": 48960,
      "2": 58540,
      "3": 66709,
      "4": 80726
    },
    HI: {
      "1": 78788,
      "2": 92578,
      "3": 104704,
      "4": 125621
    },
    IA: {
      "1": 60971,
      "2": 81351,
      "3": 95739,
      "4": 115320
    },
    ID: {
      "1": 62738,
      "2": 77719,
      "3": 87960,
      "4": 97212
    },
    IL: {
      "1": 67102,
      "2": 84892,
      "3": 101951,
      "4": 122289
    },
    IN: {
      "1": 60725,
      "2": 75774,
      "3": 89800,
      "4": 102605
    },
    KS: {
      "1": 61158,
      "2": 79752,
      "3": 88271,
      "4": 113151
    },
    KY: {
      "1": 55971,
      "2": 66902,
      "3": 75700,
      "4": 94937
    },
    LA: {
      "1": 53028,
      "2": 64762,
      "3": 73393,
      "4": 91366
    },
    MA: {
      "1": 80467,
      "2": 100535,
      "3": 127172,
      "4": 162422
    },
    MD: {
      "1": 80002,
      "2": 103083,
      "3": 122385,
      "4": 151613
    },
    ME: {
      "1": 61440,
      "2": 79014,
      "3": 95531,
      "4": 119122
    },
    MI: {
      "1": 63380,
      "2": 75374,
      "3": 93873,
      "4": 111606
    },
    MN: {
      "1": 71643,
      "2": 90946,
      "3": 114267,
      "4": 141324
    },
    MO: {
      "1": 61165,
      "2": 75277,
      "3": 89515,
      "4": 109302
    },
    MP: {
      "1": 32878,
      "2": 32878,
      "3": 38251,
      "4": 56260
    },
    MS: {
      "1": 48603,
      "2": 60981,
      "3": 70950,
      "4": 86573
    },
    MT: {
      "1": 64836,
      "2": 77872,
      "3": 84019,
      "4": 109438
    },
    NC: {
      "1": 60072,
      "2": 74849,
      "3": 87369,
      "4": 107128
    },
    ND: {
      "1": 70125,
      "2": 90049,
      "3": 93240,
      "4": 124290
    },
    NE: {
      "1": 65223,
      "2": 83790,
      "3": 99845,
      "4": 115269
    },
    NH: {
      "1": 83877,
      "2": 98248,
      "3": 136886,
      "4": 151546
    },
    NJ: {
      "1": 83898,
      "2": 99056,
      "3": 122540,
      "4": 155510
    },
    NM: {
      "1": 54193,
      "2": 69208,
      "3": 71283,
      "4": 82110
    },
    NV: {
      "1": 63473,
      "2": 75983,
      "3": 86618,
      "4": 95950
    },
    NY: {
      "1": 68814,
      "2": 84958,
      "3": 103444,
      "4": 126167
    },
    OH: {
      "1": 61955,
      "2": 76131,
      "3": 90912,
      "4": 110062
    },
    OK: {
      "1": 55358,
      "2": 69182,
      "3": 77166,
      "4": 90043
    },
    OR: {
      "1": 69653,
      "2": 84418,
      "3": 101989,
      "4": 118493
    },
    PA: {
      "1": 66454,
      "2": 80321,
      "3": 100888,
      "4": 122083
    },
    PR: {
      "1": 29175,
      "2": 29175,
      "3": 32807,
      "4": 41038
    },
    RI: {
      "1": 70858,
      "2": 90196,
      "3": 109514,
      "4": 130123
    },
    SC: {
      "1": 59511,
      "2": 72416,
      "3": 82114,
      "4": 100609
    },
    SD: {
      "1": 57253,
      "2": 82039,
      "3": 92794,
      "4": 104379
    },
    TN: {
      "1": 57246,
      "2": 71828,
      "3": 85014,
      "4": 95796
    },
    TX: {
      "1": 60040,
      "2": 77611,
      "3": 87228,
      "4": 101753
    },
    UT: {
      "1": 72772,
      "2": 81900,
      "3": 102941,
      "4": 111065
    },
    VA: {
      "1": 75376,
      "2": 93328,
      "3": 111017,
      "4": 134252
    },
    VI: {
      "1": 38846,
      "2": 46687,
      "3": 49778,
      "4": 54537
    },
    VT: {
      "1": 69936,
      "2": 86394,
      "3": 103763,
      "4": 126550
    },
    WA: {
      "1": 83121,
      "2": 96890,
      "3": 116345,
      "4": 138487
    },
    WI: {
      "1": 63146,
      "2": 81854,
      "3": 99261,
      "4": 118441
    },
    WV: {
      "1": 56420,
      "2": 62974,
      "3": 81964,
      "4": 90258
    },
    WY: {
      "1": 65457,
      "2": 82531,
      "3": 93651,
      "4": 104487
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9900 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// const unsorted = Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});
// Object.keys(unsorted)
//   .sort()
//   .reduce((acc, key) => {
//     acc[key] = unsorted[key];
//     return acc;
//   }, {});